<template>
  <div class="mt-5" v-observe-visibility="{
          callback: visibilityChanged,
          once: true,
          rootMargin: '-300px'
        }">
    <section class="bg-blue">
      <div class="container-lg">
        <h2>{{ $t('events_question') }}</h2>
        <EventTable :data="tableData" />
      </div>
    </section>
  </div>
</template>


<script>
import EventTable from "./EventTable";

export default {
  name: "Events",
  components: {
    EventTable,
  },
  computed: {
    tableData() {
      return this.$store.getters.eventTableData;
    },
  },
  methods: {
    visibilityChanged(isVisible) {
      if (isVisible) {
        this.$store.dispatch("getEventProb");
      }
    },
  },
};
</script>